module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "tab",
    class: _vm.customerCss
  }, _vm._l((_vm.dataSource), function(item, $index) {
    return _c('div', {
      staticClass: "tab-container",
      style: (_vm.width)
    }, [_c('div', {
      staticClass: "tab-item",
      class: _vm.index === $index ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.itemClick($index, item)
        }
      }
    }, [_vm._v("\n       " + _vm._s(item.name) + "\n       ")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa58557"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue-components/tab/tab.vue
// module id = 278
// module chunks = 1